import React, { useState } from "react";
import { Box, IconButton, CircularProgress } from '@mui/material';
import sendRequest from '../utils/sendRequest';
import RefreshIcon from '@mui/icons-material/Refresh';
import LargeTooltip from '../styled/CustomTooltip';

export default function WorksheetAutomationsIcon({ po_doc_id, addSnackbar }) {
  const [loadingAuto, setLoadingAuto] = useState(false);

  const runAutomations = async () => {
    setLoadingAuto(true);
    try {
      let response = await sendRequest(`purchase-orders/run-worksheet-automations?po_doc_id=${po_doc_id}`);
      addSnackbar(response.message);
    } catch (error) {
      addSnackbar(error.message, false);
    } finally {
      setLoadingAuto(false);
    }
  }

  return (
    <LargeTooltip title="Run Worksheet Automations" arrow>
      <span>
        <IconButton
          onClick={runAutomations}
          disabled={loadingAuto}
          aria-label="run worksheet automations"
          sx={{ p: 0.5, width: 32, height: 32 }}
        >
          {loadingAuto ? (
            <Box
              sx={{
                width: 20,
                height: 20,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <CircularProgress size={20} color="primary" />
            </Box>
          ) : (
            <RefreshIcon color="primary"/>
          )}
        </IconButton>
      </span>
    </LargeTooltip>
    );
}